module.exports = __webpack_public_path__ + "img/system-pump.c73c8767.png";